import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';
import { colors } from './colors';

/** Color único de iconos de acción en tablas (#2563eb). */
export const TABLE_ACTION_ICON_COLOR = colors.primary.main;

export const tableActionIconButtonSx: SxProps<Theme> = {
  color: TABLE_ACTION_ICON_COLOR,
  '&:hover': {
    backgroundColor: alpha(TABLE_ACTION_ICON_COLOR, 0.12),
    color: TABLE_ACTION_ICON_COLOR,
  },
};
